import MemoryListPage from '../src/pages/MemoryListPage';

export default MemoryListPage;
